import React from 'react';

import { AreaUnitsProvider } from '$contexts/area-units';
import { ExchangeRateProvider } from '$contexts/exchange-rate';
import { Footer, Header } from '$partials/global';
import { ModuleDispatcher } from '$partials/modules';
import { OfficeDetailsColumn } from '$partials/modules/blocks';
import { SimpleImage } from '$partials/media';
import { MarketSchema } from '$partials/markets';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages').MarketPage}
 */
const MarketPage = (props) => {
    const page = props.data.page;

    return (
        <AreaUnitsProvider defaultUnit={page?.areaUnit === 'sqm' || page?.areaUnit === 'sqft' ? page.areaUnit : undefined}>
            <ExchangeRateProvider
                defaultCurrency={page?.priceCurrency}
                exchangeRate={props.data?.exchangeRates}>
                <MarketSchema
                    offices={page?.offices}
                    page={page}
                    url={props?.location} />
                <Header {...props.data.header} />

                <main id='main-content'>
                    <section className='theme-light-alt bg-main-background'>
                        <div className='layout-container layout-site-outer-padding md:pt-160 md:pb-48'>
                            <h1 className='text-main-text-primary type-style-1'>
                                {page?.title}
                            </h1>
                        </div>

                        {page?.coverImage && (
                            <SimpleImage
                                className='w-full h-[245px] sm:h-[540px] md:h-[810px] object-cover'
                                {...page.coverImage}/>
                        )}
                    </section>

                    {page?.modules?.length > 0 && (
                        <section className='theme-light-alt'>
                            {page.modules.map((module, i) => (
                                <ModuleDispatcher
                                    {...module}
                                    key={i + module?.id} />
                            ))}
                        </section>
                    )}

                    {page?.offices?.edges?.length > 0 && (
                        <OfficeDetailsColumn
                            offices={page?.offices}
                            officesHeading={page?.officesHeading}
                            officesSubheading={page?.officesSubheading} />
                    )}
                </main>

                <Footer {...props.data.footer} />
            </ExchangeRateProvider>
        </AreaUnitsProvider>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default MarketPage;
